module.exports = __webpack_public_path__ + "img/icon3.c228e73c.png";